import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { BillingAccessorialApprovalRequest } from "../../../app/data/shipment-reconciliation/models";
import { BillingAccessorialApprovalState } from "../ShipmentReconciliationState";

const initialState: BillingAccessorialApprovalState = {
  loading: false,
  loadingFailed: false,
  loaded: false
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const billingAccessorialApprovalSlice = createSlice({
  name: "billingAccessorialApprovalSlice",
  initialState,
  reducers: {
    resetBillingAccessorialApprovalState: (state) => initialState,
    billingAccessorialApprovalLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    billingAccessorialApprovalSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
    },
    billingAccessorialApprovalLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  resetBillingAccessorialApprovalState,
  billingAccessorialApprovalLoadingStarted,
  billingAccessorialApprovalSucceed,
  billingAccessorialApprovalLoadingFailed
} = billingAccessorialApprovalSlice.actions;

export const billingAccessorialApprovalSelector = (state: IState) => state.billingAccessorialApproval;

export const submitBillingAccessorialApproval = (
  shipmentWorkItemId: number,
  accessorialId: string,
  requestData: BillingAccessorialApprovalRequest,
  onSuccess?: () => void,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(billingAccessorialApprovalLoadingStarted());
  const response = await shipmentReconciliationService.submitBillingAccessorialApproval(
    shipmentWorkItemId,
    accessorialId,
    requestData
  );
  if (response.ok() && response.data) {
    dispatch(billingAccessorialApprovalSucceed(response.data));
    onSuccess && onSuccess();
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(billingAccessorialApprovalLoadingFailed(error));
    onError && onError(error)
  }
};

const billingAccessorialApprovalReducer = billingAccessorialApprovalSlice.reducer;
export default billingAccessorialApprovalReducer;